<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div
    aria-live="assertive"
    class="z-50 fixed inset-0 flex items-end justify-center px-4 py-6 mt-10 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
  >
    <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="notificationStore.notification"
        class="z-20 w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black/5"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <ld-icon
                class="w-6 h-6 text-green-400"
                :class="{
                  'text-teal-400': notificationStore.notification.type === 'Success',
                  'text-orange-400': notificationStore.notification.type === 'Warning',
                  'text-red-400': notificationStore.notification.type === 'Error',
                }"
                aria-hidden="true"
                :icon="notificationStore.notification.icon"
              />
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">
                {{ notificationStore.notification.title }}
              </p>
              <p class="mt-1 text-sm text-gray-500">
                {{ notificationStore.notification.message }}
              </p>
            </div>
            <div class="flex flex-shrink-0 ml-4">
              <button
                class="inline-flex text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="notificationStore.clearNotification()"
              >
                <span class="sr-only">Close</span>
                <XIcon
                  class="w-5 h-5"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { XIcon } from '@heroicons/vue/solid'
  // import LDIcon from './LDIcon.vue'
  import { useNotificationStore } from '/@/store/notificationStore'
  const notificationStore = useNotificationStore()

  const show = computed(() => {
    return notificationStore.notification !== undefined
  })

  watch(
    () => notificationStore.notification?.timeout,
    () => {
      if (notificationStore.notification?.timeout) {
        setTimeout(
          () => notificationStore.clearNotification(),
          notificationStore.notification?.timeout,
        )
      }
    },
  )
</script>
